import { useEffect } from 'react'
import * as styles from './styles'
import { ContentfulImage } from '../../elements/ContentfulImage'
import type { IImageLink } from 'contentful-shared'
import { useState } from 'react'
import type { Asset } from 'contentful-shared/types'
import Link from 'next/link'

type LogoListItemProps = {
  logo: IImageLink
}

type LogoImageProps = {
  image: Asset
}

const LogoImage = ({ image }: LogoImageProps) => {
  const [svg, setSvg] = useState<string | null>(null)

  const url = image?.fields?.file?.url ? `https:${image.fields.file.url}` : null
  const isSvg = image?.fields?.file?.contentType === 'image/svg+xml'

  useEffect(() => {
    if (url && isSvg) {
      fetch(url)
        .then(res => res.text())
        .then(setSvg)
    }
  }, [url])

  if (!image) {
    return false
  }

  if (isSvg) {
    return (
      <styles.LogoWrap
        {...(svg && { dangerouslySetInnerHTML: { __html: svg } })}
      />
    )
  }

  // rendering a regular image
  return (
    <styles.LogoWrap>
      <ContentfulImage
        fill={false}
        height={0}
        width={0}
        style={{ height: '100%', width: 'auto' }}
        image={image}
      />
    </styles.LogoWrap>
  )
}

export const LogoListItem = ({ logo }: LogoListItemProps) => {
  const url = logo?.fields?.link
  const target = logo?.fields?.openInANewTab ? '_blank' : undefined

  if (url) {
    return (
      <Link href={url} target={target}>
        <LogoImage image={logo?.fields?.icon} />
      </Link>
    )
  }

  return <LogoImage image={logo?.fields?.icon} />
}
